export default __webpack_public_path__ + "static/Epilogue-SemiBold-23bebee2439c7fb06dd8e784e3627cee.ttf";